import { useEffect, useState } from 'react';
import Addon from '../models/Addon';

// Does this site offer any elementary add-ons to customers? Decides whether an
// order package goes on to the add-ons page (utils/afterAddRoute). The same
// filter the add-ons picker lists, so the answer matches what it would show.
export default function useHasElementaryAddons() {
  const [hasAddons, setHasAddons] = useState(false);

  useEffect(() => {
    Addon
      .where({ isElementary: true, visibleToCustomers: true })
      .per(0)
      .stats({ total: 'count' })
      .all()
      .then((res) => setHasAddons(res.meta.stats.total.count > 0))
      .catch(() => setHasAddons(false));
  }, []);

  return hasAddons;
}
